export default __webpack_public_path__ + "src/assets/membership-purchase.de0ffbefcaaaa19c15e0d3c0b5270b40.svg";